import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAll = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.49996 4.16675H10.8333C11.2916 4.16675 11.6666 4.54175 11.6666 5.00008C11.6666 5.45841 11.2916 5.83342 10.8333 5.83342H2.49996C2.04163 5.83342 1.66663 5.45841 1.66663 5.00008C1.66663 4.54175 2.04163 4.16675 2.49996 4.16675ZM2.49996 7.50008H10.8333C11.2916 7.50008 11.6666 7.87508 11.6666 8.33342C11.6666 8.79175 11.2916 9.16675 10.8333 9.16675H2.49996C2.04163 9.16675 1.66663 8.79175 1.66663 8.33342C1.66663 7.87508 2.04163 7.50008 2.49996 7.50008ZM15 10.8334V8.33342C15 7.87508 14.625 7.50008 14.1666 7.50008C13.7083 7.50008 13.3333 7.87508 13.3333 8.33342V10.8334H10.8333C10.375 10.8334 9.99996 11.2084 9.99996 11.6667C9.99996 12.1251 10.375 12.5001 10.8333 12.5001H13.3333V15.0001C13.3333 15.4584 13.7083 15.8334 14.1666 15.8334C14.625 15.8334 15 15.4584 15 15.0001V12.5001H17.5C17.9583 12.5001 18.3333 12.1251 18.3333 11.6667C18.3333 11.2084 17.9583 10.8334 17.5 10.8334H15ZM7.49996 12.5001H2.49996C2.04163 12.5001 1.66663 12.1251 1.66663 11.6667C1.66663 11.2084 2.04163 10.8334 2.49996 10.8334H7.49996C7.95829 10.8334 8.33329 11.2084 8.33329 11.6667C8.33329 12.1251 7.95829 12.5001 7.49996 12.5001Z",
		fill: "currentColor"
	})
});
export default SvgAll;
